import { useState } from "react";

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleReservation = () => {
    // Aquí puedes agregar la lógica para la reserva
    window.open('https://wa.me/8119991511?text=Hola,%20me%20gustaría%20reservar%20una%20mesa', '_blank');
  };

  return (
    <nav className="bg-amber-50 shadow-lg fixed w-full z-50">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          {/* Mobile menu button */}
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <button
              type="button"
              className="relative inline-flex items-center justify-center rounded-md p-2 text-amber-700 hover:bg-amber-100 hover:text-amber-900 focus:ring-2 focus:ring-amber-500 focus:outline-none focus:ring-inset transition-colors"
              aria-controls="mobile-menu"
              aria-expanded={mobileMenuOpen}
              onClick={toggleMobileMenu}
            >
              <span className="sr-only">Open main menu</span>
              {mobileMenuOpen ? (
                <svg className="block w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="block w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              )}
            </button>
          </div>

          {/* Logo and brand */}
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div className="flex shrink-0 items-center">
              <h1 className="text-xl sm:text-2xl font-bold text-amber-800 truncate">
                arveta·house
              </h1>
              <p className="ml-2 text-xs sm:text-sm text-amber-700 hidden md:block">
                coffee & brunch
              </p>
            </div>

            {/* Desktop navigation */}
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-2 lg:space-x-4">
                <a 
                  href="#home" 
                  className="rounded-md px-2 lg:px-3 py-2 text-sm font-medium text-amber-800 hover:bg-amber-100 hover:text-amber-900 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Inicio
                </a>
                <a 
                  href="#about" 
                  className="rounded-md px-2 lg:px-3 py-2 text-sm font-medium text-amber-700 hover:bg-amber-100 hover:text-amber-900 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Nosotros
                </a>
                <a 
                  href="#gallery" 
                  className="rounded-md px-2 lg:px-3 py-2 text-sm font-medium text-amber-700 hover:bg-amber-100 hover:text-amber-900 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Galería
                </a>
                <a 
                  href="#contact" 
                  className="rounded-md px-2 lg:px-3 py-2 text-sm font-medium text-amber-700 hover:bg-amber-100 hover:text-amber-900 transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Contacto
                </a>
              </div>
            </div>
          </div>

          {/* Desktop reservation button */}
          <div className="hidden sm:flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
            <button
              type="button"
              onClick={handleReservation}
              className="bg-amber-600 hover:bg-amber-700 text-white px-3 lg:px-4 py-2 rounded-full text-sm font-medium transition-colors shadow-md hover:shadow-lg transform hover:scale-105 duration-200 flex items-center space-x-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span className="hidden lg:inline">Reservar Mesa</span>
              <span className="lg:hidden">Reservar</span>
            </button>
          </div>

          {/* Mobile reservation button (visible only on mobile) */}
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:hidden">
            <button
              type="button"
              onClick={handleReservation}
              className="bg-amber-600 hover:bg-amber-700 text-white px-3 py-1.5 rounded-full text-xs font-medium transition-colors shadow-md"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`sm:hidden transition-all duration-300 ease-in-out ${mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="space-y-1 px-2 pt-2 pb-3 bg-amber-50 border-t border-amber-200">
          <a 
            href="#home" 
            className="block rounded-md px-3 py-3 text-base font-medium text-amber-800 hover:bg-amber-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div className="flex items-center space-x-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Inicio</span>
            </div>
          </a>
          <a 
            href="#about" 
            className="block rounded-md px-3 py-3 text-base font-medium text-amber-700 hover:bg-amber-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div className="flex items-center space-x-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Nosotros</span>
            </div>
          </a>
          <a 
            href="#gallery" 
            className="block rounded-md px-3 py-3 text-base font-medium text-amber-700 hover:bg-amber-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div className="flex items-center space-x-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>Galería</span>
            </div>
          </a>
          <a 
            href="#contact" 
            className="block rounded-md px-3 py-3 text-base font-medium text-amber-700 hover:bg-amber-100 transition-colors"
            onClick={() => setMobileMenuOpen(false)}
          >
            <div className="flex items-center space-x-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <span>Contacto</span>
            </div>
          </a>
          
          {/* Mobile reservation button in menu */}
          <div className="pt-4 pb-2 border-t border-amber-200">
            <button
              type="button"
              onClick={() => {
                handleReservation();
                setMobileMenuOpen(false);
              }}
              className="w-full bg-amber-600 hover:bg-amber-700 text-white px-4 py-3 rounded-lg text-base font-medium transition-colors shadow-md flex items-center justify-center space-x-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>Reservar Mesa</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
